import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { AxiosApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LIST_REPORTS_QUERY_KEY } from './useFetchListReports';

export const useDeleteReport = ({
  onSuccess,
  onError,
}: {
  onSuccess?: () => void;
  onError?: (error: string) => void;
} = {}) => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();

  const tenantId = getTenantId();

  const { mutate, isPending } = useMutation({
    mutationFn: (id: string) => api.reports.deleteReport(tenantId, id).then(() => {}),
    onSuccess: () => {
      queryClient.resetQueries({ queryKey: [LIST_REPORTS_QUERY_KEY], exact: false });
      onSuccess?.();
    },
    onError: (error: AxiosApiError) => {
      onError?.(error.message || 'Failed to delete report');
    },
  });

  return {
    mutate,
    isPending,
  };
};
